import { Link as RouterLink } from 'react-router-dom';
import { Box, Text } from '@primer/react';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      as="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: 'border.default',
        paddingX: ['24px', '48px', '100px'],
        paddingY: 4,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: ['column', 'row', 'row'],
          alignItems: ['flex-start', 'center', 'center'],
          justifyContent: 'space-between',
          gap: 3,
        }}
      >
        <Text sx={{ fontSize: 1, color: 'fg.muted' }}>
          © {year} Pegasus UX. Dallas, TX. All rights reserved.
        </Text>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Box
            as={RouterLink}
            to="/services"
            sx={{ fontSize: 1, color: 'fg.muted', textDecoration: 'none', ':hover': { color: 'fg.default' } }}
          >
            Services
          </Box>
          <Box
            as={RouterLink}
            to="/how-we-work"
            sx={{ fontSize: 1, color: 'fg.muted', textDecoration: 'none', ':hover': { color: 'fg.default' } }}
          >
            How We Work
          </Box>
          <Box
            as={RouterLink}
            to="/insights"
            sx={{ fontSize: 1, color: 'fg.muted', textDecoration: 'none', ':hover': { color: 'fg.default' } }}
          >
            Insights
          </Box>
          <Box
            as={RouterLink}
            to="/contact"
            sx={{ fontSize: 1, color: 'fg.muted', textDecoration: 'none', ':hover': { color: 'fg.default' } }}
          >
            Contact
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
